import {
	CreateUserRequest,
	CreateUserResponse,
	PasswordResetRequest,
	PasswordResetResponse,
	StatusUpdateRequest,
	StatusUpdateResponse,
	UpdateUserRequest,
	UserDetails,
} from '../@types';
import axiosInstance from './axios-instance';
import { User, Page, Notification } from '../@types';
import { handleError } from './utils';

/**
 * Creates a user
 */
export const createUser = (user: CreateUserRequest) =>
	axiosInstance.post<any>('/user/createUser/', user).catch(handleError);

/**
 * Gets a user by id
 */
export const getUser = (userID: string) => {
	return axiosInstance
		.get<UserDetails>('/user/getuser/id', {
			params: { id: userID },
		})
		.catch(handleError);
}

/**
 * Gets a user's notifications by their id
 */
 export const getNotifications = () => {
	 let userID = 0 // Set this as the user's id

	return axiosInstance
		.get<UserDetails>('/user/getNotifications')
		.catch(handleError);
}

export const deleteNotification = (notification: Notification) => {
	return axiosInstance
		.delete('/user/deleteNotification', { data: { notification } })
		.catch(handleError)
}

/**
 * Gets a page of users
 */
export const getUsers = () =>
	axiosInstance.get<UserDetails[]>(`/user/getallusers/`).catch(handleError);



/**
 * Gets a page of users
 */
 export const getExperts = () =>
 axiosInstance.get<UserDetails[]>(`/user/getExperts/`).catch(handleError);


/**
 * Updates a user's status
 */
export const updateUserById = (user: UpdateUserRequest) =>
	axiosInstance
		.put<UpdateUserRequest>('/user/updateUser/', user)
		.catch(handleError);

/**
 * Updates a user's password'
 */
export const changePassword = (passwordResetRequest: PasswordResetRequest) =>
	axiosInstance
		.post<PasswordResetResponse>(
			'/user/changePassword',
			passwordResetRequest
		)
		.catch(handleError);

/**
 * Deletes a user by id
 */
export const deleteUser = (id: string) =>
	axiosInstance
		.delete('/user/deleteUserById', { data: { id: id } })
		.catch(handleError);


